/**
 * Regex Pattern for wide characters
 */
export const WideCharactersPattern = new RegExp(
  '[\\u1100-\\u11FF]' + // IsHangulJamo
  '|[\\u2E80-\\u2EFF]' + // IsCJKRadicalsSupplement
  '|[\\u3000-\\u303F]' + // IsCJKSymbolsandPunctuation
  '|[\\u3040-\\u309F]' + // IsHiragana
  '|[\\u30A0-\\u30FF]' + // IsKatakana
  '|[\\u3130-\\u318F]' + // IsHangulCompatibilityJamo
  '|[\\u3200-\\u32FF]' + // IsEnclosedCJKLettersandMonths
  '|[\\u3300-\\u33FF]' + // IsCJKCompatibility
  '|[\\u3400-\\u4DBF]' + // IsCJKUnifiedIdeographsExtensionA
  '|[\\u4E00-\\u9FFF]' + // IsCJKUnifiedIdeographs
  '|[\\uAC00-\\uD7AF]' + // IsHangulSyllables
  '|[\\uF900-\\uFAFF]' + // IsCJKCompatibilityIdeographs
  '|[\\uFE30-\\uFE4F]' + // IsCJKCompatibilityForms
  '|[\\uFF01-\\uFF60]' + // Fullwidth Forms Part 1
  '|[\\uFFE0-\\uFFE6]' + // Fullwidth Forms Part 2
  '|[\\uD800-\\uDBFF][\\uDC00-\\uDFFF]' + // Astral Planes
  '|\\u2741' + // ❁
  '|\\u25E1' + // ◡
  '|\\u2727' + // ✧
  '|\\u03C9' + // ω
  '|\\u2266' + // ≦
  '|\\u2267' + // ≧
  '|\\u25BD' + // ▽
  '|\\u2022' // •
  , 'g'
);
